import { AlertErrorCircle } from '@/assets/icons'

export default function InlineTipError(message: string) {
  return (
    <div className="rounded-lg bg-red-50 p-3 my-2 grid grid-cols-[45px_auto] items-center">
      <div className="px-2 py-1 text-red-700">
        <AlertErrorCircle className="w-5 h-5" />
      </div>
      <span className={'inline-block text-xs text-red-900 text-opacity-70'}>{message}</span>
    </div>
  )
}
